import React, { useCallback } from 'react';
import { Button, MainLayout, Triptych } from '@app/components';
import { KitchenAreaList, KitchenAreaDeleteModal, KitchenAreaCreate, KitchenAreaUpdate } from '@app/features/KitchenArea';
import { useResourceScreenHelpers } from '@app/hooks';
import { kitchenAreaApi } from '@app/store';
import { IKitchenArea } from '@app/common';
import { RouteProp, useFocusEffect, useRoute } from '@react-navigation/native';
import { RootStackParamList } from '@app/types';
import { SettingHeader } from '@app/features/SettingHeader';
import { CheckPermissions } from '@app/components/CheckPermissions';

export const KitchenAreaScreen = () => {
  const route = useRoute<RouteProp<RootStackParamList, 'KitchenAreaScreen'>>();

  const [readOne, { isFetching }] = kitchenAreaApi.useLazyReadOneKitchenAreasQuery();
  const [deleteOne, { isLoading }] = kitchenAreaApi.useDeleteOneKitchenAreasMutation();

  const { triptych, modal, onDelete, onUpdate, mode, selectedItem, item: kitchenArea } = useResourceScreenHelpers<IKitchenArea>();

  const openCard = async (item: Partial<IKitchenArea>) => {
    onUpdate(readOne({
      filters: { _id: { $eq: item?._id } },
    }), item)
  }

  useFocusEffect(
    useCallback(() => {
      if (Boolean(route.params?._id)) {
        openCard({ _id: route.params._id, name: "Chargement..." });
      }
    }, [route])
  );

  return (
    <MainLayout
      header={(
        <SettingHeader>
          <CheckPermissions permissions={['dashboard::kitchen-areas.create']}>
            <Button
              onPress={() => triptych.open({ mode: 'CREATE' })}
              title='Ajouter un lieu de fabrication' />
          </CheckPermissions>
        </SettingHeader>
      )}>

      <KitchenAreaDeleteModal
        {...modal}
        onDelete={(kitchenArea) => onDelete(deleteOne(kitchenArea._id!))}
        isLoading={isLoading} />

      <Triptych
        list={(
          <KitchenAreaList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onUpdate={openCard}
            onDelete={modal.open} />
        )}
        form={(
          mode === 'CREATE'
            ? <KitchenAreaCreate />
            : <KitchenAreaUpdate
              kitchenArea={kitchenArea ?? selectedItem}
              toggle={(mode) => mode === 'UPDATE' ? openCard(selectedItem) : triptych.close()}
              isFetching={isFetching}
              onDelete={modal.open} />
        )} />
    </MainLayout>
  );
};

